import config from '../config';

const exportSettings = {
	APP_ID: config.ONE_SIGNAL_APP_ID,
	SAFARI_ID: config.ONE_SIGNAL_SAFARI_ID,
};

export default exportSettings;
